<template>
  <div id="app">
    <router-view/>
    <div v-if="isStaging" class="watermark"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isStaging: process.env.VUE_APP_MODE === 'staging'
      
    };
  }
};
</script>

<style>
@import './resources/assets/css/styles.css';
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
  background: repeating-linear-gradient(
    -45deg,
    rgba(255, 0, 0, 0.02) 0,
    rgba(255, 0, 0, 0.02) 10px,
    transparent 10px,
    transparent 20px
  );
}
.watermark::after {
  content: "STAGING";
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10rem;
  color: rgba(255, 0, 0, 0.1);
  white-space: nowrap;
}
</style>
